var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"home",style:(_vm.pageStyle)},[_vm._l((_vm.pageData.components),function(item,index){return _c('div',{key:index},[_c(item.pageComponent,{tag:"component",attrs:{"data":item},on:{"msg":_vm.diyMsg}})],1)}),_c('tabbar')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }